import type { LogClient, LogDescriptor } from '../../core/log/client';
import { Rfc6962Client } from '../../core/rfc6962/client';
import { TiledClient } from '../../core/tiled/client';
import { TileCache } from '../../core/tiled/tilecache';
import { transport } from './transport';
import { readJson, writeJson } from './storage';

const cache = new Map<string, LogClient>();
const PAGE_KEY = 'ct:pageSize:v1';
/** Shared across tiled logs: keys include the monitoring URL, so there is no cross-log mixing. */
export const tileCache = new TileCache({ maxEntries: 512 });

/** Client factory: one client per log, remembering observed RFC 6962 batch caps across sessions. */
export function getClient(log: LogDescriptor): LogClient {
  let c = cache.get(log.id);
  if (c) return c;
  if (log.kind === 'rfc6962') {
    const sizes = readJson<Record<string, number>>(PAGE_KEY, {});
    const opts: ConstructorParameters<typeof Rfc6962Client>[2] = {
      onPageSize: (n) => writeJson(PAGE_KEY, { ...readJson<Record<string, number>>(PAGE_KEY, {}), [log.id]: n }),
    };
    const remembered = sizes[log.id];
    if (remembered !== undefined) opts.initialPageSize = remembered;
    c = new Rfc6962Client(log, transport, opts);
  } else {
    c = new TiledClient(log, transport, tileCache);
  }
  cache.set(log.id, c);
  return c;
}

export function forgetClients(): void {
  cache.clear();
}
